module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-7.5b3c08c6.jpg";